import React, { Component } from "react";

function App(props) {
    const { data, i18n } = props;
    const { riasecModel, mappingObj } = i18n.report;

    const getTagLeft = (value) => 200 + 630 * value / 100 + "px";

    return (
        <div className="riasec-wrap">
        	<p className="riasec-text">{riasecModel.infoText1}</p>
        	<p className="riasec-text">{riasecModel.infoText2}</p>
            <div className="riasec-table">
            	<div className="riasec-table-tr">
            		<div className="riasec-table-th"></div>
            		<div className="riasec-table-th">{riasecModel.low}</div>
            		<div className="riasec-table-th">{riasecModel.med}</div>
            		<div className="riasec-table-th">{riasecModel.high}</div>
            	</div>
            	<div className="riasec-table-tr">
            		<div className="riasec-table-td"><span className="bgColor14">{mappingObj.stressReaction}</span></div>
            		<div className="riasec-table-td">{riasecModel.stressReactionText1}</div>
            		<div className="riasec-table-td">{riasecModel.stressReactionText2}</div>
            		<div className="riasec-table-td">{riasecModel.stressReactionText3}</div>
            		<div className="riasec-table-arrow fontColor14">
            			<div>0</div>
            			<div>100</div>
            		</div>
            		<div className="riasec-table-tag bgColor14-opacity" style={{ left: getTagLeft(data.stress_reaction.value) }}></div>
            	</div>
            	<div className="riasec-table-tr">
            		<div className="riasec-table-td"><span className="bgColor15">{mappingObj.outgoing}</span></div>
            		<div className="riasec-table-td">{riasecModel.outgoingText1}</div>
            		<div className="riasec-table-td">{riasecModel.outgoingText2}</div>
            		<div className="riasec-table-td">{riasecModel.outgoingText3}</div>
            		<div className="riasec-table-arrow fontColor15">
            			<div>0</div>
            			<div>100</div>
            		</div>
            		<div className="riasec-table-tag bgColor15-opacity" style={{ left: getTagLeft(data.outgoing.value) }}></div>
            	</div>
            	<div className="riasec-table-tr">
            		<div className="riasec-table-td"><span className="bgColor16">{mappingObj.creativity}</span></div>
            		<div className="riasec-table-td">{riasecModel.creativityText1}</div>
            		<div className="riasec-table-td">{riasecModel.creativityText2}</div>
            		<div className="riasec-table-td">{riasecModel.creativityText3}</div>
            		<div className="riasec-table-arrow fontColor16">
            			<div>0</div>
            			<div>100</div>
            		</div>
            		<div className="riasec-table-tag bgColor16-opacity" style={{ left: getTagLeft(data.creativity.value) }}></div>
            	</div>
            	<div className="riasec-table-tr">
            		<div className="riasec-table-td"><span className="bgColor17">{mappingObj.agreeableness}</span></div>
            		<div className="riasec-table-td">{riasecModel.agreeablenessText1}</div>
            		<div className="riasec-table-td">{riasecModel.agreeablenessText2}</div>
            		<div className="riasec-table-td">{riasecModel.agreeablenessText3}</div>
            		<div className="riasec-table-arrow fontColor17">
            			<div>0</div>
            			<div>100</div>
            		</div>
            		<div className="riasec-table-tag bgColor17-opacity" style={{ left: getTagLeft(data.agreeableness.value) }}></div>
            	</div>
            	<div className="riasec-table-tr">
            		<div className="riasec-table-td"><span className="bgColor18">{mappingObj.conscientiousness}</span></div>
            		<div className="riasec-table-td">{riasecModel.conscientiousnessText1}</div>
            		<div className="riasec-table-td">{riasecModel.conscientiousnessText2}</div>
            		<div className="riasec-table-td">{riasecModel.conscientiousnessText3}</div>
            		<div className="riasec-table-arrow fontColor18">
            			<div>0</div>
            			<div>100</div>
            		</div>
            		<div className="riasec-table-tag bgColor18-opacity" style={{ left: getTagLeft(data.conscientiousness.value) }}></div>
            	</div>
        	</div>
        </div>
    );
}

export default App;
